import { loadView } from '@/router'

export default [
  {
    path: 'assets',
    name: 'configuration-assets',
    component: loadView('Application/Configuration/Assets'),
    redirect: {
      name: 'configuration-assets-types'
    },
    children: [
      {
        path: 'types',
        name: 'configuration-assets-types',
        component: loadView('Application/Configuration/Assets/AssetTypes')
      },
      {
        path: 'manufacturers',
        name: 'configuration-assets-manufacturers',
        component: loadView('Application/Configuration/Assets/Manufacturers')
      },
      {
        path: 'models',
        name: 'configuration-assets-models',
        component: loadView('Application/Configuration/Assets/Models')
      }
    ]
  }
]
